/**
 * Almikia Epic E5 (TASK-034): lowercase hex SHA-256 of a file, computed
 * client-side with Web Crypto before the upload is registered
 * (`document_versions.sha256` must match `^[0-9a-f]{64}$`).
 *
 * Web Crypto has no incremental digest, so the file is read once as an
 * `ArrayBuffer` and hashed natively (off the main thread in browsers); that is
 * fast and non-blocking for the 10 MB bucket limit.
 */
export async function computeSha256Hex(data: Blob): Promise<string> {
  const buffer = await data.arrayBuffer();
  const digest = await crypto.subtle.digest("SHA-256", buffer);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
